import { render, staticRenderFns } from "./MoveDragHandle.vue?vue&type=template&id=58f5e602&scoped=true&"
import script from "./MoveDragHandle.vue?vue&type=script&lang=ts&"
export * from "./MoveDragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./MoveDragHandle.vue?vue&type=style&index=0&id=58f5e602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5e602",
  null
  
)

export default component.exports